import { LitElement, html } from './vendor_lit3-core.min.js';

const SUPPORTED_LOCALES = ['da', 'en', 'sv', 'no'];
const DEFAULT_LOCALE = 'en';
// Shopify uses both 'no' and 'nb' for Norwegian depending on store setup.
const shopLocale = Shopify.locale === 'nb' ? 'no' : Shopify.locale;
const locale = SUPPORTED_LOCALES.includes(shopLocale) ? shopLocale : DEFAULT_LOCALE;

const TRANSLATION_RELEASE = {
  da: 'Release',
  en: 'Release',
  sv: 'Release',
  no: 'Release',
};

const TRANSLATION_OUT_NOW = {
  da: 'Ude nu',
  en: 'Out now',
  sv: 'Ute nu',
  no: 'Ute nå',
};

class DtCountdownTimer extends LitElement {
  static properties = {
    // The target date in string form (e.g. ISO string)
    to: { type: String },
    // Internal state: the parsed Date instance
    targetDate: { state: true },
    // Internal state: remaining time in milliseconds
    remainingTime: { state: true },
    // Whether the countdown has completed
    completed: { type: Boolean, reflect: true },
  };

  constructor() {
    super();
    this.to = null;
    this.targetDate = null;
    this.remainingTime = null;
    this.completed = false;
    this.timerId = null;
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.to) {
      this.targetDate = new Date(this.to);
      this.updateCountdown();
      this.timerId = setInterval(() => {
        this.updateCountdown();
        this.requestUpdate();
      }, 1000);
    }
  }

  disconnectedCallback() {
    if (this.timerId) clearInterval(this.timerId);
    super.disconnectedCallback();
  }

  updateCountdown() {
    if (!this.targetDate) return;
    const now = new Date();
    this.remainingTime = this.targetDate - now;
    if (this.remainingTime <= 0) {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
      this.completed = true;
      this.dispatchEvent(new CustomEvent('complete'));
    }
  }

  generateRelativeTimeString(remainingTime) {
    // Use our module-level "locale" for consistent translations.
    const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'always' });
    const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

    if (days > 0) {
      return `${rtf.format(days, 'day')} ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(
        seconds
      ).padStart(2, '0')}`;
    } else if (hours > 0) {
      return `${rtf.format(hours, 'hour')} ${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    } else if (minutes > 0) {
      return `${rtf.format(minutes, 'minute')} ${String(seconds).padStart(2, '0')}`;
    } else {
      return rtf.format(seconds, 'second');
    }
  }

  render() {
    if (!this.to) {
      return html`...`;
    }
    if (this.completed) {
      return html`${TRANSLATION_OUT_NOW[locale]}!`;
    }
    const timeString = this.generateRelativeTimeString(this.remainingTime);
    return html`${TRANSLATION_RELEASE[locale]}:<br />${timeString}`;
  }
}

customElements.define('dt-countdown-timer', DtCountdownTimer);
